<template>
  <div>
    <section
      class="building-map"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
        '--map-marker-color': markerColor,
        '--map-marker-scale': markerScale,
        '--map-svg-top-offset': svgTopOffset
      }"
    >
      <SvgMap :map="mapData" :path-click="pathClick" :marker-click="markerClick" ref="svgMap" />
    </section>
    <Podlazie v-if="floor && building" ref="floor" :stage="stage" :floor="floor" :building="building" :filter="filter"/>
  </div>
</template>

<script>
import SvgMap from "./SvgMap";
import Podlazie from "./Podlazie";
import mapsData from "@/data/maps.json"
import store from "@/store";
import ScrollTo from "@/utils/scrollTo.util"
import {mapActions} from "vuex";

export default {
  name: "BuildingMap",
  components: {SvgMap, Podlazie},
  props: {
    stage: {
      type: String,
      required: true
    },
    mapKey: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: String,
      required: true
    },
    markerColor: {
      type: String,
      required: true
    },
    markerScale: {
      type: Number,
      default: 1
    },
    svgTopOffset: {
      type: String,
      default: '0'
    },
    // e.g. { label: 'B2', text: 'Družstevné bývanie' } - marks one building marker
    // as a cross-sell to another project instead of a regular availability marker
    crossSellMarker: {
      type: Object,
      default: null
    },
    // when true, a fully sold-out marker gets an extra 'soldout' class (greyed text)
    // to visually distinguish it from a marker that's merely "not for sale yet"
    distinguishSoldOut: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: null,
      mapData: mapsData[this.mapKey],
      building: this.$route.params.building || null,
      floor: this.$route.params.floor || null
    }
  },

  async mounted() {
    await this.loadFlats()
    this._updateMarkersText()
    this._updateFloorsClasses()
    this.$root.$on('filterChanged', (val) => {
      this.floor = val;
    })
  },

  methods: {
    ...mapActions('flats', ['loadFlats']),
    pathClick: function (oEvent) {
      const data = oEvent.target.dataset.map.split("-")
      this.building = data[0]
      this.floor = data[1]
      this.filter = {
        stages: this.stage,
        dates: [],
        buildings: [this.building],
        rooms: [],
        floors: [this.floor],
        availability: 0,
        priceVat: null,
        totalArea: null
      }

      this.$root.$emit('setFilter',
          {
            stages: this.stage,
            dates: [],
            buildings: [this.building],
            rooms: [],
            floors: [this.floor],
            availability: 0,
            priceVat: null,
            totalArea: null
          }
      )
      setTimeout(() => ScrollTo.id(this, 'floor-plan'), 500)
    },

    markerClick: function (oEvent) {
      if(oEvent.target.parentElement.classList.contains('empty')
          || oEvent.target.classList.contains('empty'))
        return

      const data = oEvent.target.dataset.label
          || oEvent.target.parentElement.dataset.label

      this.$root.$emit('setFilter',
          {
            stages: this.stage,
            dates: [],
            buildings: [data],
            rooms: [],
            floors: [],
            availability: 0,
            priceVat: null,
            totalArea: null
          }
      )
      ScrollTo.id(this, 'tabulka')
    },

    _updateFloorsClasses: function () {
      this.mapData.paths.forEach( (f, i) => {
        const data = f.data.mapId.split("-")
        const count = store.getters["flats/getFreeFlatsByBuildingAndFloor"](this.stage, data[0], data[1], data[4], data[5])
        this.mapData.paths[i].class = count > 0 ? 'path' : 'hidden'
      })
    },
    _updateMarkersText: function () {
      this.mapData.markers.forEach( (m, i) => {
        const count = store.getters["flats/getFreeFlatsByBuildings"](this.stage, m.label)
        const prereserved = store.getters["flats/getPreReservedFlatsByBuildings"](this.stage, m.label)

        if (this.crossSellMarker && m.label === this.crossSellMarker.label) {
          this.mapData.markers[i].class = 'custom'
          this.mapData.markers[i].text = this.crossSellMarker.text
        } else if (prereserved > 0 && count === 0) {
          this.mapData.markers[i].class = 'empty'
          this.mapData.markers[i].text = this.$t('Nie je v predaji')
        } else if (count) {
          this.mapData.markers[i].text = this.$t('V predaji')
        } else {
          this.mapData.markers[i].class = this.distinguishSoldOut ? 'empty soldout' : 'empty'
          this.mapData.markers[i].text = this.$t('Vypredané')
        }
      })

      this.$refs.svgMap.$forceUpdate()
    }
  }
}
</script>

<style lang="sass">
.building-map
  background-repeat: no-repeat
  background-size: cover
  position: relative

  svg
    position: relative
    z-index: 2
    width: 100%
    height: auto
    top: var(--map-svg-top-offset, 0)
    .marker
      fill: var(--map-marker-color)
      cursor: pointer
      transform: scale(var(--map-marker-scale, 1))
    .marker-wrapper.empty
      .empty
        fill: white
      &.soldout
        text
          fill: #ccc
      text
        fill: var(--map-marker-color)
    .marker-wrapper.custom
      .custom
        fill: white
      text
        fill: var(--map-marker-color)
        &.text
          font-size: 55%
    .marker-wrapper:not(.empty)
      text
        cursor: pointer
    .hidden
      display: none
    .path
      fill: transparent
      transition: all linear .2s
      &:hover
        fill: var(--map-marker-color)
        cursor: pointer
        opacity: .85

</style>
